import { render, staticRenderFns } from "./SelectPsyHistory.vue?vue&type=template&id=74372d86&scoped=true&"
import script from "./SelectPsyHistory.vue?vue&type=script&lang=js&"
export * from "./SelectPsyHistory.vue?vue&type=script&lang=js&"
import style0 from "./SelectPsyHistory.vue?vue&type=style&index=0&id=74372d86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74372d86",
  null
  
)

export default component.exports